import React from 'react';
import { FormItemCard } from '../../FormItemCard';
import { budgetRangeOptions } from 'common/constants/publicationForm.constants';
import { Radio, Space } from 'antd';
import { Text } from '@components/common';

const BudgetRange = ({
  values,
  handleSelectTimeRange,
  currentFocus,
  handleGoBackQuestion,
  handleGoForwardQuestion,
  displayDistinctQuestion,
}) => {
  return (
    <FormItemCard
      name="budget_range"
      title="¿Cuál es tu presupuesto?"
      subTitle={'Elige una opción'}
      isCurrent={currentFocus == 'budget_range'}
      id={'budget_range-container'}
      handleGoForwardQuestion={handleGoForwardQuestion}
      handleGoBackQuestion={handleGoBackQuestion}
      displayDistinctQuestion={displayDistinctQuestion}>
      <Radio.Group
        value={values['budget_range']?.name}
        disabled={currentFocus == 'budget_range' ? false : true}>
        <Space direction="vertical">
          {budgetRangeOptions?.map((item) => {
            return (
              <Radio
                onChange={() => handleSelectTimeRange(item)}
                value={item.name}
                key={`mult-opt-${item.id}`}>
                <Text>{item.name}</Text>
              </Radio>
            );
          })}
        </Space>
      </Radio.Group>
    </FormItemCard>
  );
};

export default BudgetRange;
